import { createUseStyles } from 'react-jss'

const styleOverride = createUseStyles({
  root: {
    userSelect: 'none',
    width: '28px',
    height: '30px',
    display: 'inline-block',
    fill: 'none',
    flexShrink: 0,
  },
})

export default styleOverride
